module.exports = __webpack_public_path__ + "img/2.282b4409.png";